// material-ui
import { Theme } from '@mui/material/styles';

// project import
import getColors from 'utils/getColors';

// types
import { ExtendedStyleProps } from 'types/extended';

// ==============================|| CHIP - COLORS ||============================== //

function getColorStyle({ color, theme }: ExtendedStyleProps) {
  const colors = getColors(theme, color);
  const { light, lighter, main } = colors;

  return {
    color: theme.palette.text.primary,
    backgroundColor: lighter,
    border: `1px solid ${light}`,
    '& .MuiChip-deleteIcon': {
      color: main,
      '&:hover': {
        color: light
      }
    }
  };
}

// ==============================|| OVERRIDES - CHIP ||============================== //

export default function Chip(theme: Theme) {
  const defaultLightChip = getColorStyle({ color: 'secondary', theme });
  return {
    MuiChip: {
      styleOverrides: {
        root: {
          borderRadius: 4,
          margin: '0px 3px',
          '&:active': {
            boxShadow: 'none'
          },
          '&.MuiChip-colorDefault': getColorStyle({ color: 'primary', theme }),
          '&.MuiChip-colorPrimary': getColorStyle({ color: 'primary', theme }),
          '&.MuiChip-colorSecondary': getColorStyle({ color: 'secondary', theme }),
          '&.MuiChip-colorError': getColorStyle({ color: 'error', theme }),
          '&.MuiChip-colorInfo': getColorStyle({ color: 'info', theme }),
          '&.MuiChip-colorSuccess': getColorStyle({ color: 'success', theme }),
          '&.MuiChip-colorWarning': getColorStyle({ color: 'warning', theme }),
          '& .MuiChip-icon': {
            marginLeft: 8
          },
          '& .MuiChip-deleteIcon': { fontSize: '16px'}
        },
        sizeLarge: {
          fontSize: '1rem',
          height: 40
        },
        sizeMicro: {
          fontSize: '0.625rem',
          height: 18,
          '& .MuiChip-label': {
            paddingLeft: 6,
            paddingRight: 6
          },
          '& .MuiChip-icon': {
            fontSize: '0.75rem',
            marginLeft: 4
          },
          '& .MuiChip-deleteIcon': {
            fontSize: '0.75rem'
          }
        },
        light: {
          ...defaultLightChip,
          '&.MuiChip-lightPrimary': getColorStyle({ color: 'primary', theme }),
          '&.MuiChip-lightSecondary': getColorStyle({ color: 'secondary', theme }),
          '&.MuiChip-lightError': getColorStyle({ color: 'error', theme }),
          '&.MuiChip-lightInfo': getColorStyle({ color: 'info', theme }),
          '&.MuiChip-lightSuccess': getColorStyle({ color: 'success', theme }),
          '&.MuiChip-lightWarning': getColorStyle({ color: 'warning', theme })
        },
        combined: {
          // border: '1px solid',
          ...defaultLightChip,
          '&.MuiChip-combinedPrimary': getColorStyle({ color: 'primary', theme }),
          '&.MuiChip-combinedSecondary': getColorStyle({ color: 'secondary', theme }),
          '&.MuiChip-combinedError': getColorStyle({ color: 'error', theme }),
          '&.MuiChip-combinedInfo': getColorStyle({ color: 'info', theme }),
          '&.MuiChip-combinedSuccess': getColorStyle({ color: 'success', theme }),
          '&.MuiChip-combinedWarning': getColorStyle({ color: 'warning', theme })
        }
      }
    }
  };
}
